import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=242caa94&scoped=true&"
import script from "./Registrations.vue?vue&type=script&lang=js&"
export * from "./Registrations.vue?vue&type=script&lang=js&"
import style0 from "./Registrations.vue?vue&type=style&index=0&id=242caa94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242caa94",
  null
  
)

export default component.exports